import { css } from 'emotion';
import theme from '@lyearn-team/theme-config';

export const headerRoot = (isMobile, height) => css`
  background: ${theme.color.dark.uranus};
  display: flex;
  width: 100vw;
  height: ${height ? `${height}px` : '90px'};
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  position: relative;
  text-transform: uppercase;
  .headerText {
    ${isMobile &&
      css`
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      `}
  }
  .link {
    position: absolute;
    left: 30px;
    .Icon {
      fill: white;
    }
  }
  @media (max-width: 767px) {
    height: 56px;
    padding: 0 5px 0 20px;
    .link {
      left: 10px;
    }
  }
`;
